import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue
} from '@/components/shadcn/Select';

type Props = {
  value: number;
  onChange: (arg: number) => void;
  optionElements: JSX.Element[];
  placeholder: string;
  className: string;
};

export default function AnnualIncome({
  value,
  onChange,
  optionElements,
  placeholder,
  className
}: Props) {
  return (
    <Select
      value={String(value)}
      onValueChange={(annualincome: string) => onChange(Number(annualincome))}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder}>
          {value ? `${value}万円` : ''}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>{optionElements}</SelectContent>
    </Select>
  );
}
